export default __webpack_public_path__ + "static/resultsSlides-d4430e54625264259546062e78a73731.gif";